var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"item",attrs:{"to":_vm.to,"flat":"","tile":""}},[_c('v-img',{staticClass:"img",attrs:{"src":_vm.files + _vm.img + '?resize=1&w=400',"alt":_vm.title},on:{"error":_vm.imgError}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }